import {useMutation} from '@tanstack/react-query';
import {getHealthSpecialtyAuthorization} from '../../services/getHealthSpecialtyAuthorization';

export function useGetHealthSpecialtyAuthorizationMutation() {
	return useMutation({
		mutationFn: getHealthSpecialtyAuthorization,
	});
}
